import styled, { css } from 'styled-components';

import { Container } from '@/components/Container';

export const StyledContainer = styled(Container)<{ isDesktop: boolean }>`
  ${({ isDesktop, theme }) => css`
    background-color: ${isDesktop ? 'none' : theme.colors.white};
    padding-top: ${theme.spacing(5)};
    padding-bottom: ${theme.spacing(5)};
  `}
`;
